import { S as o } from "./Skeleton.js";
import { jsx as t } from "react/jsx-runtime";
import { $ as a } from "./barsLoader.js";
const p = o, r = {
  sm: 15,
  md: 25,
  lg: 50,
  xl: 75,
  "2xl": 100
}, d = ({ size: e = "md" }) => /* @__PURE__ */ t(
  a,
  {
    height: r[e],
    width: r[e],
    radius: "5",
    color: "#000000",
    ariaLabel: "three-dots-loading",
    wrapperStyle: {},
    wrapperClass: "",
    visible: !0
  }
);
export {
  p as S,
  d as T
};
